export default function Kettle() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_3717)">
                <path
                    d="M22 11C22.1713 11.0136 23.3361 10.9828 23.5 11C26.5 11 28 13.4849 28 15.5C28 16.5 27.5 18.5 25.9338 19.6737C25.762 19.7844 24.6863 19.8932 24.5 20"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M9.77148 11C8.8826 11 7.54926 11 5.77148 11C6.04845 11.6079 7.30598 14.3305 8.00014 14.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 3C16.2762 3 16.5262 3.11194 16.7071 3.29293C16.8881 3.47388 17 3.72387 17 4C17 4.27613 16.8881 4.52612 16.7071 4.70707C16.5262 4.88806 16.2762 5 16 5C15.7238 5 15.4738 4.88806 15.2929 4.70707C15.1119 4.52612 15 4.27613 15 4C15 3.72387 15.1119 3.47388 15.2929 3.29293C15.4738 3.11194 15.7238 3 16 3Z"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M24.8506 25.932C24.8627 25.8083 24.8742 25.6841 24.8849 25.5595C24.9606 24.6795 25 23.7767 25 22.8567C25 18.4849 24.1114 14.5018 22.6541 11.5064C21.0081 8.12319 18.6364 6 16 6C13.3528 6 10.9725 8.14064 9.32568 11.5481C7.88036 14.5387 7 18.5051 7 22.8567C7 23.7949 7.04093 24.7152 7.11962 25.6118C7.13102 25.7417 7.14322 25.8711 7.1562 26"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path d="M10 11H23" stroke="black" strokeWidth="1.5" />
                <path d="M15 23H17" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <rect x="5.75" y="25.75" width="20.5" height="2.5" rx="1.25" stroke="black" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_10719_3717">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
